export const isMissingPatientValue = (value) => {
  if (value === null || value === undefined) return true;
  const text = String(value).trim();
  if (!text) return true;
  const lower = text.toLowerCase();
  return lower === "na" || lower === "n/a" || lower === "null" || lower === "none";
};

export const hasExternalUhid = (value) => !isMissingPatientValue(value);

export const getPatientDisplayUhid = (record) => {
  if (!record) return null;
  const external = record.external_uhid ?? record.patient_external_uhid;
  if (hasExternalUhid(external)) return String(external).trim();
  const system = record.uhid ?? record.patient_uhid;
  if (!isMissingPatientValue(system)) return String(system).trim();
  return null;
};

export const formatPatientDisplayUhid = (record, fallback = "—") =>
  getPatientDisplayUhid(record) ?? fallback;
